function mixin(receiver) {
  for (let i = 1; i < arguments.length; i++) {
    const supplier = arguments[i];
    if (Object.getOwnPropertyDescriptor) {
      Object.keys(supplier).forEach(property => {
        let descriptor = Object.getOwnPropertyDescriptor(supplier, property);
        Object.defineProperty(receiver, property, descriptor);
      });
    } else {
      for (let property in supplier) {
        if (supplier.hasOwnProperty(property)) {
          receiver[property] = supplier[property];
        }
      }
    }
  }
  return receiver;
}

export default mixin;



// WEBPACK FOOTER //
// ./src/js/mixins/mixin.js